import { IFavoritesCompetitions } from '@/app/models/favorite/competition-favorite.model';
import { CompetitionFavoritesService } from '@/app/services/favorite';
import { RoutingService } from '@/app/services/routing.service';
import { TranslationService } from '@/app/services/translation.service';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { environment } from '@environments/environment';
import { ICompetitionSummary } from '../../models';

export interface CompetitionDetails {
  id: string;
  logo?: string;
  name?: string;
  season?: string;
  country?: string;
  logoCountry?: string;
  nameEn?: string;
  nameEs?: string;
}

@Component({
  selector: 'app-competition-details-card',
  standalone: true,
  imports: [],
  templateUrl: './competition-details-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompetitionDetailsCardComponent {
  private fCompetitionService = inject(CompetitionFavoritesService);
  private routingService = inject(RoutingService);
  private translationService = inject(TranslationService);

  competitionDetails = input.required<ICompetitionSummary>();

  isFavoriteCompetition = computed(() =>
    this.fCompetitionService.favoritesService
      .idsCompetitionFavorites()
      .includes(this.competitionDetails().Id)
  );

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  getCompetitionName() {
    return this.translationService.getTraduccionName(
      this.competitionDetails().NameTranslation,
      this.competitionDetails().Name
    );
  }

  getCompetitionLogo() {
    return this.competitionDetails().ImageUrl || this.urlIMG + 'default.png';
  }

  getCompetitionSeason() {
    return this.translationService.getTraduccionName(
      this.competitionDetails().NameTranslation,
      this.competitionDetails().Name
    );
  }

  getCompetitionUrl() {
    const competitionId = this.competitionDetails().Id;

    return this.routingService.getTraslateUrlCompetitionDetails(
      {
        es: this.competitionDetails().NameTranslation?.['es'],
        en: this.competitionDetails().NameTranslation?.['en'],
      },
      this.competitionDetails()?.Name ?? '',
      competitionId
    );
  }

  toogleFavoriteCompetition() {
    if (!this.fCompetitionService.favoritesService.validAuthFavorites()) return;

    const id = this.competitionDetails().Id;
    const isFavorite = this.isFavoriteCompetition();

    const bodyData: IFavoritesCompetitions = {
      CountryName: this.competitionDetails().ImageUrl || '',
      CountryNameTranslation: {
        en: this.competitionDetails().ImageUrl || '',
        es: this.competitionDetails().ImageUrl || '',
      },
      Id: this.competitionDetails().Id,
      ImageUrl: this.competitionDetails().ImageUrl || '',
      IsFavorite: isFavorite,
      Name: this.competitionDetails().Name || '',
      NameTranslation: {
        en: this.translationService.getTraduccionName(
          this.competitionDetails().NameTranslation,
          this.competitionDetails().Name
        ),
        es: this.translationService.getTraduccionName(
          this.competitionDetails().NameTranslation,
          this.competitionDetails().Name
        ),
      },
      TsExternalId: this.competitionDetails().Id,
      Link: this.getCompetitionUrl(),
    };

    if (isFavorite) {
      this.fCompetitionService.deleteCompetitionFavorites(id);
    } else {
      this.fCompetitionService.setCompetitionFavorites(id, bodyData);
    }
  }
}
